export default {
  name: 'buttonwrap',
  props: {
    mb: {
      type: String,
      default: ''
    },
    has: {
      type: Boolean,
      default: false
    },
    cover: {
      type: Boolean,
      default: false
    },
    txt: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  methods: {
    next: function next() {
      this.$emit('btnSure');
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};